import { getFadeInAnimation } from '@anm/styles/helpers';
import slick from '@anm/styles/third-party/slick';
import styled from 'styled-components';

const SliderWrapper = styled.div`
  pointer-events: all;

  ${slick}
  .slick-slider {
    opacity: 0;
    visibility: hidden;
    &.slick-initialized {
      ${getFadeInAnimation()};
    }
  }
  .slick-dots {
    bottom: -15px;

    li {
      width: 8px;
      height: 8px;
      margin: 0 6px;

      &.slick-active {
        button {
          background-color: #fff;
        }
      }

      button {
        width: 100%;
        height: 100%;
        transition: 0.3s;
        border-radius: 50%;
        background-color: #919eaa;
        display: block;
        padding: 0;

        &:before {
          display: none;
        }
      }
    }
  }
`;

export default SliderWrapper;
